import { useEffect, useRef } from 'react';

export interface PosShortcutHandlers {
  onSearchFocus: () => void;
  onFindClient: () => void;
  onNewProduct: () => void;
  onChangeQuantity: () => void;
  onReload: () => void;
  onDiscount: () => void;
  onPaymentMethod: () => void;
  onRemoveProduct: () => void;
  onSuspendSale: () => void;
  onNewSale: () => void;
  onViewSales: () => void;
  onCheckout: () => void;
}

export const SHORTCUTS: { key: string; action: string }[] = [
  { key: 'F1', action: 'Buscar producto' },
  { key: 'F2', action: 'Buscar cliente' },
  { key: 'F3', action: 'Nuevo producto' },
  { key: 'F4', action: 'Cambiar cantidad' },
  { key: 'F5', action: 'Actualizar productos' },
  { key: 'F6', action: 'Descuento' },
  { key: 'F7', action: 'Método de pago' },
  { key: 'F8', action: 'Eliminar producto' },
  { key: 'F9', action: 'Suspender venta' },
  { key: 'F10', action: 'Nueva venta' },
  { key: 'F11', action: 'Ventas' },
  { key: 'F12', action: 'Cobrar' },
  { key: 'ENTER', action: 'Seleccionar / confirmar' },
  { key: 'ESC', action: 'Cancelar / cerrar' },
  { key: 'SPACE', action: 'Seleccionar / acción rápida' },
];

export function usePosShortcuts(handlers: PosShortcutHandlers) {
  const ref = useRef(handlers);
  ref.current = handlers;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!e.key.startsWith('F')) return;
      if (e.key.length > 3) return;
      e.preventDefault();
      const h = ref.current;
      const map: Record<string, () => void> = {
        F1: h.onSearchFocus,
        F2: h.onFindClient,
        F3: h.onNewProduct,
        F4: h.onChangeQuantity,
        F5: h.onReload,
        F6: h.onDiscount,
        F7: h.onPaymentMethod,
        F8: h.onRemoveProduct,
        F9: h.onSuspendSale,
        F10: h.onNewSale,
        F11: h.onViewSales,
        F12: h.onCheckout,
      };
      map[e.key]?.();
    };

    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}